import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from '../components/Header';
import TickerBanner from '../components/ticker/TickerBanner';
import Hero from '../components/Hero';
import Promise from '../components/Promise';
import AssessmentCard from '../components/AssessmentCard';
import HowItWorks from '../components/HowItWorks';
import ComparisonMatrix from '../components/ComparisonMatrix';
import Footer from '../components/Footer';
import { assessments } from '../data/assessments';

const currentAssessments = assessments.filter(
  assessment => ['pa', 'pia', 'dpia'].includes(assessment.id)
);

export default function HomePage() {
  const location = useLocation();
  const needsCentering = currentAssessments.length % 3 === 1;

  useEffect(() => {
    if (location.state?.scrollTo) {
      const element = document.getElementById(location.state.scrollTo);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
      window.history.replaceState({}, document.title);
    }
  }, [location]);

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <TickerBanner />
      <Hero />
      
      <div className="bg-white py-12" id="assessments">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-3xl mx-auto mb-12">
            <div className="inline-block">
              <h2 className="text-3xl font-bold mb-4 relative font-montserrat text-gray-700">
                Assessments
                {/* Decorative underline */}
                <div className="absolute -bottom-2 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-brand-primary to-transparent opacity-75" />
              </h2>
            </div>
            <p className="text-lg text-gray-600 mt-6">
              
            </p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {currentAssessments.map((assessment, index) => (
              <div
                key={assessment.id}
                className={
                  needsCentering && index === currentAssessments.length - 1
                    ? 'md:col-span-2 lg:col-span-1 lg:col-start-2'
                    : ''
                }
              >
                <AssessmentCard assessment={assessment} />
              </div>
            ))}
          </div>
        </div>
      </div>

      <HowItWorks />
      <ComparisonMatrix />
      <Promise />
      <Footer />
    </div>
  );
}